

import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaHeadset, FaInstagram, FaLinkedin, FaStar, FaSyncAlt, FaTruck, FaTwitter } from 'react-icons/fa';
import CustomerReview from "./CustomerReview";
import Slider from "react-slick";
import Testimonials from "./TestiMonial";
const About = () => {
  const [activeTab, setActiveTab] = useState("introduction");
  

  const tabs = [
{ 
  id: "introduction", 
  label: "Introduction", 
  content: `At Vanathara, we celebrate the rich heritage and vibrant traditions of Wayanad. Our brand is rooted in the essence of this lush land, bringing you the finest spices, handcrafted goods, and unique artisanal products that reflect the culture and craftsmanship of the region.
We are committed to supporting local artisans and farmers, ensuring that every product you receive tells a story of passion, quality, and authenticity. From the aromatic spices that enhance your culinary experiences to the exquisite handicrafts that add charm to your home, Vanthara is more than a brand—it’s a journey into the heart of Wayanad.
Experience the spirit of tradition, nature, and creativity with Vanathara, where every purchase nurtures local communities and preserves the timeless heritage of our land.` 
},

   {
  id: "vision",
  label: "Vision",
  content: `Our vision at Vanthara is to bring the rich heritage of Wayanad to the world, celebrating its natural bounty and artisanal craftsmanship. We aim to empower local communities, preserve traditional skills, and create authentic, high-quality products that connect people to the essence of our land.`
},
   {
  id: "what-sets-us-apart",
  label: "What Sets Us Apart",
  content: `Vantharastands out by blending tradition with quality. Our products are sourced directly from Wayanad’s artisans and farmers, ensuring authenticity in every spice and handcrafted item. We focus on sustainability, craftsmanship, and supporting local communities, making every purchase a meaningful connection to the heart of Wayanad.`
},

   {
  id: "commitment",
  label: "Our Commitment",
  content: `At Vanathara, we are committed to quality, authenticity, and sustainability. We support local artisans and farmers, ensuring every product is crafted with care and respect for tradition. Our promise is to deliver products that not only enrich your lifestyle but also nurture communities and preserve the cultural heritage of Wayanad.`
},

  ];

 const teamMembers = [
    { 
      name: "Annette Black", 
      role: "Founder/CEO",
      image: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=500&q=80" 
    },
    { 
      name: "Jane Cooper", 
      role: "Sales Director",
      image: "https://images.unsplash.com/photo-1551836022-d5d88e9218df?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=500&q=80" 
    },
    { 
      name: "Brooklyn Simmons", 
      role: "Manager",
      image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=500&q=80" 
    },
    { 
      name: "Theresa Webb", 
      role: "Product Manager",
      image: "https://images.unsplash.com/photo-1517841905240-472988babdf9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=500&q=80" 
    }
  ];

  return (
    <div className="bg-white">
      <div className="container py-4">
        <div className="row align-items-center mb-4">
          {/* Image */}
          <div className="col-lg-5 mb-4 mb-lg-0">
            <img
              src="https://happybellyfish.com/wp-content/uploads/2021/07/Which-spices-are-used-in-Indian-cooking.png"
            alt="Modave Model"
              className="img-fluid rounded"
              style={{
                height: "350px",
                objectFit: "cover",
                width: "100%",
              }}
            />
          </div>

          {/* Content */}
          <div className="col-lg-7">
            <h1 className="h3 fw-bold mb-3 text-dark">
            Vanthara– Where Nature, Tradition, and Craft Unite
            </h1>

          
<div className="d-flex overflow-auto mb-3" style={{ whiteSpace: "nowrap" }}>
  <ul className="nav border-0 flex-row flex-md-wrap flex-nowrap">
    {tabs.map((tab) => (
      <li className="nav-item flex-shrink-0 flex-md-fill text-center" key={tab.id} style={{ minWidth: "120px" }}>
        <button
          className={`nav-link position-relative text-dark px-3 py-2 small fw-medium border-0 bg-transparent w-100 ${
            activeTab === tab.id ? "fw-semibold" : ""
          }`}
          onClick={() => setActiveTab(tab.id)}
        >
          {tab.label}
          {activeTab === tab.id && (
            <span
              style={{
                position: "absolute",
                bottom: 0,
                left: "50%",
                transform: "translateX(-50%)",
                width: "60%",
                height: "2px",
                backgroundColor: "#e63946",
              }}
            ></span>
          )}
        </button>
      </li>
    ))}
  </ul>
</div>

            <p className="mb-3 text-secondary ">
              {tabs.find((tab) => tab.id === activeTab)?.content}
            </p>

            {/* <button className="btn btn-dark btn-sm px-4 py-2 small">
              Read More
            </button> */}
          </div>
        </div>

      
     


      </div>
   

      <div>
    <Testimonials/>
</div>
     {/* <div className="container py-5"> */}
        {/* <div className="row justify-content-center"> */}
          {/* <div className="col-lg-8 text-center mb-5">
            <h2 className="h1 fw-bold mb-3">Meet Our Teams</h2>
            <p className="text-muted">
              Discover exceptional experiences through testimonials from our satisfied customers.
            </p>
          </div> */}
        {/* </div> */}
        
        {/* <div className="row"> */}
          {/* {teamMembers.map((member, index) => (
            <div key={index} className="col-lg-3 col-md-6 mb-4">
              <div className="card border-0 text-center team-member-card">
                <div className="position-relative">
                  <div className="rounded-circle overflow-hidden mx-auto mb-3" 
                    style={{width: '180px', height: '180px'}}>
                    <img 
                      src={member.image} 
                      alt={member.name}
                      className="img-fluid w-100 h-100 object-fit-cover"
                    />
                  </div>
                  <div className="team-social-icons position-absolute top-0 end-0 m-2">
                    <div className="bg-white rounded-circle d-flex align-items-center justify-content-center" style={{width: '35px', height: '35px'}}>
                      <FaInstagram className="text-dark" />
                    </div>
                    <div className="bg-white rounded-circle d-flex align-items-center justify-content-center mt-2" style={{width: '35px', height: '35px'}}>
                      <FaTwitter className="text-dark" />
                    </div>
                    <div className="bg-white rounded-circle d-flex align-items-center justify-content-center mt-2" style={{width: '35px', height: '35px'}}>
                      <FaLinkedin className="text-dark" />
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  <h5 className="card-title fw-bold mb-1">{member.name}</h5>
                  <p className="card-text text-muted mb-0">{member.role}</p>
                </div>
              </div>
            </div>
          ))} */}
        {/* </div> */}
      {/* </div> */}
         <CustomerReview/>

           <style>{`
        .team-member-card {
          transition: transform 0.3s ease;
        }
        .team-member-card:hover {
          transform: translateY(-5px);
        }
        .team-social-icons {
          opacity: 0;
          transition: opacity 0.3s ease;
        }
        .team-member-card:hover .team-social-icons {
          opacity: 1;
        }
      `}</style>
    </div>
  );
};

export default About;
